const soldStates = [
  'MARKED_AS_SOLD',
  'PURCHASED',
  'PRODUCT_BANNED_PURCHASED',
  'USER_BANNED_PURCHASED',
];

export default function isSold(product) {
  return soldStates.includes(product.saleStatus);
}



// WEBPACK FOOTER //
// ../src/client/utils/isSold.js